module.exports = __webpack_public_path__ + "img/image2.61d8abe2.png";